import { createPaths } from "@routes/utils";

import type { IExtractRouteParamMap } from "@routes";

const baseRoute = `/report-management/sales-report/supplier-based`;

export const supplierBasedSalesReportRoutesObj = {
  list: baseRoute,
} as const;

export type ISupplierBasedSalesReportRouteParams = IExtractRouteParamMap<
  typeof supplierBasedSalesReportRoutesObj
>;

export const supplierBasedSalesReportPath = createPaths<
  typeof supplierBasedSalesReportRoutesObj,
  ISupplierBasedSalesReportRouteParams
>(supplierBasedSalesReportRoutesObj);
